// extracted by mini-css-extract-plugin
export default {"addIcon":"AddTeamButton_addIcon__hDEMa","addTeamBtn":"AddTeamButton_addTeamBtn__mF12T"};